import getApi from '../../../api/apisauceConfig'

export const deleteNotification = (id: string) =>
  getApi().delete<null>(`/admin/notifications/${id}`)
